// M005-F0067 (M005-D005 §7 amendment, WEB-BKHUB-022/021) — the Edit-booking
// link on the hub's MY-BOOKINGS cards (Upcoming and Past): same href shape,
// same accessible text, same testid on both. The destination is the booking's
// own page (/app/bookingsAdmin/<id>, M004-F0655), which lists the CALLER'S OWN
// bookings.
//
// M004-F0678 (WebUI #108): Studio cards, the Calendar day list and the shared
// booking drawer NO LONGER carry this link — for another person's booking it
// led to a page that cannot show it. They open the drawer instead. The
// `?focus=pricing` suffix is gone with the price section it scrolled to
// (M004-F0680): the one price control is the drawer's.
//
// Series rule (owner ruling 2026-09-12): a series card links to the SERIES
// MASTER booking id — the representative row the hub grouping already speaks
// in (the rule-bearing row, else the earliest row).
export const BOOKING_CARD_EDIT_LINK_TESTID = 'booking-card-edit-link';
export const BOOKING_CARD_EDIT_LINK_TEXT = 'Edit booking';

export const editBookingHref = (bookingId) => `/app/bookingsAdmin/${bookingId}`;
